module.exports = __webpack_public_path__ + "static/media/s_v5_t6.096f890c.mp3";